import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; // Ensure this CSS file includes the new styles

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Terms & Conditions | Wallabies Warm Care</title>
        <meta
          name="description"
          content="Read the terms and conditions for Wallabies Warm Care, leading producer of forced air-warming systems and blankets. Our products are designed for patient comfort and quality."
        />
      </Helmet>

      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Terms & Conditions</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            {/* Text Content Column */}
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Introduction:</b> Wallabies Warm Care is the leading producer and supplier of forced air-warming systems and blankets. We take pride in serving society with quality products. Our products are designed based on the requirements of the patients, ensuring complete comfort during use.</p>

                <p><b className="highlight">2. Booking Confirmation:</b> All product orders are confirmed upon successful payment and issuance of an order confirmation number.</p>

                <p><b className="highlight">3. Payment:</b> Full payment is required at the time of purchase. Payments can be made through our website, credit cards, or at authorized offices.</p>

                <p><b className="highlight">4. Delivery and Shipping:</b> Delivery times may vary depending on the location and availability of the products. Wallabies Warm Care ensures timely delivery and will notify customers in case of any delays.</p>

                <p><b className="highlight">5. Product Warranty:</b> All forced air-warming systems and blankets come with a warranty period as mentioned in the product documentation. Wallabies Warm Care ensures quality and durability, and will replace or repair defective products within the warranty period.</p>

                <p><b className="highlight">6. Returns and Cancellations:</b> Returns and cancellations are subject to our return policy. If the product is defective or damaged upon arrival, a return request must be made within 7 days for a full replacement or refund. Cancellations before shipping will incur a small cancellation fee.</p>

                <p><b className="highlight">7. Safety and Usage:</b> Customers must adhere to the provided instructions for safe usage of the forced air-warming systems and blankets. Wallabies Warm Care is not responsible for injuries resulting from improper use of the products.</p>

                <p><b className="highlight">8. Liability:</b> Wallabies Warm Care’s liability is limited to the replacement or repair of defective products. We are not responsible for any damages caused by the use or misuse of our products outside the prescribed guidelines.</p>

                <p><b className="highlight">9. Privacy and Security:</b> We value your privacy. All personal information collected will be kept secure and used only for order processing and customer support purposes. Refer to our Privacy Policy for further details.</p>

                <p><b className="highlight">10. Governing Law:</b> These terms and conditions are governed by the laws of India. Any disputes related to these terms will be subject to the jurisdiction of the courts in Mumbai.</p>

                <h3>General Policies</h3>
                <p><b className="highlight">Product Availability:</b> Wallabies Warm Care strives to maintain product availability. However, in case of stock shortages, customers will be notified and offered an alternative or refund.</p>

                <p><b className="highlight">Customer Support:</b> Our support team is available to assist with any inquiries related to product orders, warranties, and usage instructions. You can contact our customer support through email or phone.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Refunds:</b> If a product is eligible for a refund based on our cancellation or return policy, the refund will be processed within 5-7 working days.</p>
                <p><b className="highlight">Refund Process:</b> Refunds will be credited to the original mode of payment. Please ensure your account details are up-to-date to avoid delays.</p>
              </div>
            </div>

          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions regarding our terms, please reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+918956322311">+91 8956322311</a></li>
              <li><b>Email:</b> <a href="mailto:info@wallabieswarmcares.com">info@wallabieswarmcares.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
